<mat-icon
        [svgIcon]="getType() + '-file-custom'"
        class="file-color"
        [ngClass]="getType() + '-file'"
></mat-icon>